import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  FlightPurchaseModel,
  FlightPurchaseMutationInput,
  FlightPurchaseDeleteInput,
  FlightPurchaseUpdateInput,
} from './model';

export function useCreateFlightPurchase(
  options?: UseMutationOptions<
    ApiResult<FlightPurchaseModel>,
    ApiError,
    FlightPurchaseMutationInput
  >,
): UseMutationResult<
  ApiResult<FlightPurchaseModel>,
  ApiError,
  FlightPurchaseMutationInput
> {
  return useMutation<
    ApiResult<FlightPurchaseModel>,
    ApiError,
    FlightPurchaseMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'flight-purchases',
      method: 'POST',
      classType: FlightPurchaseModel,
      body,
    });
  }, options);
}

export function useUpdateFlightPurchase(
  options?: UseMutationOptions<
    ApiResult<FlightPurchaseModel>,
    ApiError,
    FlightPurchaseUpdateInput
  >,
): UseMutationResult<
  ApiResult<FlightPurchaseModel>,
  ApiError,
  FlightPurchaseUpdateInput
> {
  return useMutation<
    ApiResult<FlightPurchaseModel>,
    ApiError,
    FlightPurchaseUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `flight-purchases/${body.flightPurchaseId}`,
      method: 'PUT',
      classType: FlightPurchaseModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteFlightPurchase(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    FlightPurchaseDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, FlightPurchaseDeleteInput> {
  return useMutation<{ message: string }, ApiError, FlightPurchaseDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `flight-purchases/${body.flightPurchaseId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}

export function useVoidFlightPurchase(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    FlightPurchaseDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, FlightPurchaseDeleteInput> {
  return useMutation<{ message: string }, ApiError, FlightPurchaseDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `flight-purchases/${body.flightPurchaseId}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}
